import { Button, ButtonProps } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface ButtonWithLoadingProps extends ButtonProps {
  isLoading?: boolean;
}

export function ButtonWithLoading({
  isLoading,
  children,
  ...props
}: ButtonWithLoadingProps) {
  const { t } = useTranslation();

  return (
    <Button disabled={isLoading} {...props}>
      <div className="flex items-center gap-2">
        {isLoading && (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />{" "}
            <span>{t("common.loading")}</span>
          </>
        )}

        {!isLoading && children}
      </div>
    </Button>
  );
}
